<div class="ytj-haku">
  <div class="ytj-hakukentta" [class.valmis]="ytjHaunTila() === 'valmis'">
    <mat-icon>search</mat-icon>
    <input #ytjHakukentta type="text" [formField]="ytjHakusana" [placeholder]="'lasku.asiakas-dialog.ytj-haku-paikkamerkki' | translate | async" autocomplete="off" data-lpignore="true" (keydown)="kasitteleYtjHakukentanNappain($event)" (focus)="ytjListaAuki.set(true)" (blur)="suljeYtjListaViiveella()" />
    @if (ytjHaunTila() === 'haetaan') {
      <span class="ytj-haetaan">
        <span class="pyorija"></span>
        {{ 'lasku.asiakas-dialog.haetaan-ytjsta' | translate | async }}
      </span>
    } @else if (ytjHaunTila() === 'haetaan-osoitetta') {
      <span class="ytj-haetaan">
        <span class="pyorija"></span>
        {{ 'lasku.asiakas-dialog.haetaan-osoitetietoja-ytjsta' | translate | async }}
      </span>
    }
  </div>
  @if (ytjHaunTila() === 'valmis') {
    <div class="haku-valmis">
      <mat-icon>check</mat-icon>
      {{ 'lasku.asiakas-dialog.tiedot-haettu-ytjsta' | translate | async }}
    </div>
  } @else if (ytjHaunTila() === 'haku-epaonnistui') {
    <div class="ytj-haku-epaonnistui error-text">{{ 'lasku.asiakas-dialog.ytj-haku-epaonnistui' | translate | async }}</div>
  } @else if (ytjHaunTila() === 'osoitehaku-epaonnistui') {
    <div class="ytj-haku-epaonnistui error-text">{{ 'lasku.asiakas-dialog.ytj-osoitehaku-epaonnistui' | translate | async }}</div>
  }
  @if (ytjHaunTila() === 'haetaan' && ytjListaAuki()) {
    <div class="ytj-lista" aria-hidden="true">
      <div class="ytj-lista-otsikko ytj-latautuu-otsikko">
        <span class="pyorija"></span>
        {{ 'lasku.asiakas-dialog.haetaan-ytj-jarjestelmasta' | translate | async }}
      </div>
      <div class="ytj-latautumisrivi"><span style="width: 58%"></span><span style="width: 72%"></span></div>
      <div class="ytj-latautumisrivi"><span style="width: 44%"></span><span style="width: 60%"></span></div>
      <div class="ytj-latautumisrivi"><span style="width: 66%"></span><span style="width: 80%"></span></div>
    </div>
  } @else if (ytjTulokset() && ytjListaAuki() && ytjHaunTila() !== 'valmis') {
    <div class="ytj-lista">
      <div class="ytj-lista-otsikko">
        <mat-icon>business</mat-icon>
        {{ 'lasku.asiakas-dialog.ytj-lista-otsikko' | translate | async }}
      </div>
      @for (tulos of ytjTulokset(); track tulos.yritys.ytunnus; let i = $index) {
        <button type="button" [class.korostettu]="i === korostettuYtjIndeksi()" (mousedown)="$event.preventDefault(); valitseYtjYritys(tulos)" (mouseenter)="korostettuYtjIndeksi.set(i)">
          <span class="ytj-nimi"
            >{{ tulos.nimiEnnenOsumaa }}
            @if (tulos.nimenOsuma) {
              <mark>{{ tulos.nimenOsuma }}</mark>
            }
            {{ tulos.nimiOsumanJalkeen }}</span
          >
          <span class="ytj-tiedot">
            @if (tulos.osoiteteksti) {
              {{ tulos.yritys.ytunnus }} · {{ tulos.osoiteteksti }}
            } @else {
              {{ tulos.yritys.ytunnus }}
              @if (tulos.yritys.yritysmuoto) {
                · {{ tulos.yritys.yritysmuoto }}
              }
            }
          </span>
        </button>
      } @empty {
        <div class="ytj-ei-osumia">{{ 'lasku.asiakas-dialog.ytj-ei-osumia' | translate | async }}</div>
      }
    </div>
  }
</div>
